import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=25e6505e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=25e6505e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e6505e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25e6505e')) {
      api.createRecord('25e6505e', component.options)
    } else {
      api.reload('25e6505e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=25e6505e&scoped=true&", function () {
      api.rerender('25e6505e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-229E3io7NnGl6/JS/comp/DocBox.vue"
export default component.exports